// extracted by mini-css-extract-plugin
export default {"feedbackModal":"feedbackModal-module--feedback-modal--hP2cx"};